var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.4 33.8",
    style: {
      enableBackground: "new 0 0 36.4 33.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.2,25c-0.2-0.4-0.8-0.6-1.7-1c-0.9-0.4-5.3-2.6-6.1-2.9c-0.8-0.3-1.4-0.4-2,0.4c-0.6,0.9-2.3,2.9-2.8,3.5 c-0.5,0.6-1,0.7-1.9,0.2c-0.9-0.4-3.8-1.4-7.2-4.4c-2.7-2.4-4.5-5.3-5-6.1c-0.5-0.9-0.1-1.4,0.4-1.8c0.4-0.4,0.9-1,1.3-1.6 c0.4-0.5,0.6-0.9,0.9-1.5c0.3-0.6,0.1-1.1-0.1-1.6c-0.2-0.4-2-4.8-2.8-6.6C8.5-0.1,7.8,0,7.2,0C6.7,0,5.7,0.2,5.7,0.2 S3.9,0.4,3.1,1.3C2.3,2.2,0,4.3,0,8.7c0,4.4,3.2,8.6,3.7,9.2c0.4,0.6,6.2,9.9,15.3,13.4c9.1,3.6,9.1,2.4,10.7,2.2 c1.6-0.1,5.3-2.1,6-4.2C36.5,27.2,36.5,25.4,36.2,25L36.2,25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.8402824295180b34137dd0345d07d535.svg";
export { ForwardRef as ReactComponent };